/* eslint-disable */
import { urls } from "@/constant/paths";

let common = {
	// 通过一个url获取一个js
	getScript: ["", { dataType: "script", timeout: 10000 }],
	// 获取本地json文件
	getJson: ["", { dataType: "json" }],
	// 汇率查询接口
	getexrate: "exrate",
	// 通过省市区地址名称查询省市区地址信息
	getAddrDistIdByName: "post:region/queryAddrDistIdByName",
	// 通过经纬度获取附近地址
	getNearbyAddress: [
		"https://gis.sf-express.com/rgeo/api",
		{ dataType: "jsonp", jsonp: "cb", jsonpCallback: "__jp0" }
	],
	// 通过输入的值获得详细地址的信息列表
	getDetailAddList: [
		"https://gis.sf-express.com/tip/api",
		{ dataType: "jsonp", jsonp: "cb" }
	],
	// 校验月结卡号
	checkMounthAccount: ["post:cx/{account}/isCustomerCard", { async: false }],
	// 登录图片验证码
	smsUserNotification: "post:sms/user/{mobile}/notification",
	//检验腾讯验证码
	// tencentNotification: "post:sms/{mobile}/notificationByTencent:new",
	tencentNotification: "post:sms/{mobile}/notificationByTencent:new",
    // 登录geetest滑块验证码
    smsNotificationByGeetest: 'post:sms/send:new',
	// 国内收寄范围效查询
	getInternalRange: "region/new/{areaCode}/range",
	// 国际收寄范围查询
	getGlobalRange: "region/{areaCode}/globalRange",
	// 运费及时效整合查询
	getPayFee: "rate/newRates",
	// 校验代收货款卡号
	verifyCodAccount: "general/verifyCodAccount:new",
	// 获取腾讯验证码的url
	getTencentUrl: "tencent/captcha/queryCaptchaIframe:new",
	// 获取附近网点
	getNearbyStore: "store/query",
	// 根据详细地址查询网点编码
	queryDeptCode: "product/queryDeptCode:new",
	// 查询邮编详细信息
	queryPostCodeInfo: "zoneDivision/queryPostCodeInfo:new"
};

/**
 * ---------------------注册登录--------------------
 * */
let login = {
	// 手机号短信登录
	login: "post:user/sms/login:new",
	// 二维码登录状态检查
	qrLoginCheck: "user/qrcode/loginCheck:new",
	// 会员注册
	regist: "post:user/{mobile}/regist:new",
	// 登出
	logout: "post:user/logout:new",
	// 生成ticket票据
	getTicket: "user/ticket:new",
	// 判断是否是灰度用户接口
	isGrayUser: "general/gray/query:new"
};

/**
 * ---------------------下单--------------------
 * */
let order = {
	// 下单（普通、港澳台）
	submitNewOrder: "post:order/create:new",
	// 二维码下单
	submitQrNewOrder: "post:order/scan:new",
	// ACS下单检验输入的其他国家是否正确
	validACSCountry: "post:order/acs/isValidCountry",
	// ACS下单
	subACSOrder: "post:order/acs/create",
	// ACS验证运单号是否正确
	submitAcsBillNo: "post:order/acs/querySolrWaybillno",
	// ACS校验运单是否有效
	validAcsBillNo: ["post:order/acs/isValidSolrWaybillNo", { async: false }],
	// 物品名校验接口
	goodsNameCheck: "order/goodsNameCheck",
	// 物品名联想接口
	goodsNameAssociate: "order/goodsNameAssociate",
	// 新物品联想和接口
	getCargoAssociated: '/general/getCargoAssociated:new',
	// 高峰管控
	queryCustomerControlStrategy: "post:order/cxQueryBpsInfo",
	// 地址超范围查询
	queryAppointment: "post:order/queryAppointment",
	// 智能地址拆分
	addressSplit: "post:order/orderAddressSplit",
	// 单个营运异常事件提醒
	queryOrderExceptionInfo: "cx/queryOrderExceptionInfo",
	// 高峰管控平台营运异常
	bpsQueryOrderExceptionInfo: "post:order/queryBpsExceptionInfo",
	// 新包营运异常提醒
	queryOrderControl: 'post:orderControl/list:new'
};

/**
 * ---------------------运单查询管理--------------------
 * */
let waybill = {
	// 获取会员寄件列表
	getMemberSendBillInfo: ["waybills/list/send:new", { cache: false }],
	// 获取会员收件列表
	getMemberRecBillInfo: ["waybills/list/rec:new", { cache: false }],
	// 获取会员运单路由信息
	getBillDetailByNum: "waybillRoute/{id}/route:new",
	// 取消运单
	cancelAppointmentBill: "post:appointment/cancel:new",
	// 查询预约单
	changeAppointBill: [
		"appointment/{appointmentNo}/detail:new",
		{ cache: false }
	],
	// 更改预约单
	updateAppointOrder: "post:appointment/updateOrder:new",
	// 删除订单
	deleteWayBill: "post:appointment/delete:new",
	// 路由信息
	routes: "waybillRoute/{billNumbers}/routesForNoLogin:new",
	// 电子存根
	electronicStub: "memberBills/{id}/getBillEleStub",
	// 签收图
	signFigure: "memberBills/{id}/image",
	// 手机号码验证-运单列表查询路由详情
	phoneRoutes: 'waybillRoute/{billNumbers}/routesForInput:new',
	// 母单路由是否显示提示语
	parentWaybillIsPrompt: 'post:waybillRoute/parentWaybill/isPrompt:new'
};

/**
 * ---------------------地址簿管理--------------------
 * */
let addressBook = {
	// 修改或新增地址簿
	saveOrUpdateAddress: "post:address/save",
	// 多条件地址簿查询接口
	compoundQueryAddressBook: "cx/compoundQuery",
	// 获取地址簿列表
	fetchAddressBookList: function (options) {
		options.data = _.extend(
			{ pageNo: 1, rowCount: "8", condition: "" },
			options.data
		);
		this.url = "address/list:new";
		return _ajax(this.url, _.extend({ cache: false }, options));
	},
	// 从地址簿中删除一条数据
	deleteOneAddress: "post:address/{id}/delete:new",
	// 通过id获取地址簿中的一条数据
	getAddressById: "address/{id}/query:new",
	// 保存一条数据到地址簿
	saveToAddressBook: "post:address/save:new",
	// 设置默认寄件地址
	setDefaultAddress: "post:cx/addressBook/updateDefaultAddress",
	// 获取默认寄件信息
	fetchDefaultAndFirstAddress: "cx/addressBook/getDefaultAddress",
	// 上传地址簿
	uploadAddressBook: "post:address/importAddress"
};

/**
 * ---------------------区域查询相关接口--------------------
 * */
let region = {
	// 获取热门城市
	getPopularRegions: "region/popularRegions",
	// 查询下级行政区划数据
	getRegions: "region/new/{code}/subRegions",
	// 获取原寄地区域列表
	getOriginRegions: "region/{code}/subRegions",
	// 获取原寄地区域列表
	getPriceOriginRegions: "region/{code}/subRegions/origins",
	// 获取目的地区域列表
	getDestRegions: "region/A000000000/subRegions/dests",
	// 逐级IBU查询国家省市信息,(国家必传，当省为空时查省)
	getIBULevelInfo: "region/step/queryProvinceCityDistrict:new",
	// 查询IBU省市代码
	getAreaDetailByCity: "post:order/postCode/check:new"
};

/**
 * ---------------------意见反馈相关接口--------------------
 * */
let feedback = {
	// 意见反馈上传图片接口
	feedBackUpload: "post:" + urls.CX_UPLOAD,
	// 意见反馈(临时的)
	postSuggestion: ["post:cx/suggestion/save", { resLevel: 2 }]
};

/**
 * ---------------------收寄标准相关接口--------------------
 * */
const accept = {
	//获取始发地国家
	getAcceptOriginCountries: "acceptance/origins",
	//根据始发地获取目的地国家
	getAcceptDestCountries: "acceptance/dests",
	//查询收寄标准结果
	getAcceptResultIn: "post:sop/domestic/pickupDeliveryStandard:new",
	getAcceptResultOut: "sop/international/pickupDeliveryStandard:new"
};

const price = {
	// psds运费时效查询
	queryPrice: "rate/common/query",
	// psds快递运费时效(20210302)
	queryfreightPrice: "product/psds/freightPrice/query:new"
};
/**
 * ---------------------产品介绍相关接口--------------------
 * */
const product = {
	// 产品详情
	getProductDetail: "app/queryProductInfoContents"
};
/**
 * ---------------------获取在线客服链接接口----------------------
 */
var onlineService = {
	// 获取在线客服重定向URL
	getOnlineServiceUrl: "onlineService/getRedirectUrl:new"
};
/**
 * ---------------------优惠卷查询接口--------------------
 * */
const coupon = {
	getCoupons: "scs/coupon/query:new"
};

const cmsApi = {
	getHomeMenus: "mobile-home-menu:cms",
	getNews: "news:cms",
	getNotices: "notices:cms",
	getPrivacyPolicy: "privacy-policy:cms",
	getUseItem: "use-iterm:cms",
	getCompanyIntroduce: "company-introduction:cms",
	getBrandIdea: "brand-idea:cms",
	getEnterpriseHonor: "enterprise-honor:cms",
	getSustainableDevelopment: "sustainable-development:cms",
	getCorporateCulture: "corporate-culture:cms",
	getDevelopmentHistory: "development-history:cms",
	getServiceNetwork: "service-network:cms",
	// 投资者关系-公司治理
	getCorporateGovernance: "corporate-governances:cms",
	// 投资者关系-公司公告
	getCompanyAnnouncement: "company-announcements:cms",
	// 投资者关系-财务报告
	getFinancialReport: "financial-reports:cms",
	// 投资者关系-社会责任报告
	getSocialResponsibilityReports: "social-responsibility-reports:cms",
	// 投资者关系-投资者联络
	getInvestorContacts: "investor-contacts:cms",
	// 投资者关系-董事会
	getBoardOfDirector: "board-of-director:cms",
	// 投资者关系-股东会
	getBoardOfShareholder: "board-of-shareholders:cms",
	// 投资者关系-投资者活动日
	getInvestorDays: "investor-days:cms",
	// 首页轮播图
	getHomeSwiper: "home-swiper:cms",
	// 首页配置的显示
	getHomeConfig: "home-config:cms",
	// 通用规则
	getGeneralRules: "general-rules:cms",
	// 获取系统配置
	getWindowConfig: "window-config:cms",
	// 获取绿色咨询
	getGreenNews: "green-news:cms",
	generalSwitch: 'general-switch:cms',
	investorRelationsHome: 'investor-relations-home:cms',
	investorAnnouncement: 'investor-relations-announcement:cms',
	investorStock: 'investor-relations-stock-chart:cms',
	investorDirectors: 'investor-relation-director:cms',
	investorOrganization: 'investor-relation-organization:cms',
	investorSenior: 'investor-relation-senior:cms',
	investorSupervisors: 'investor-relation-supervisor:cms',
	investorManagement: 'investor-relation-management:cms',
	investorContact: 'investor-relations-contact-us:cms',
	investorBrokerage : 'investor-relation-coverage:cms',
	investorReport: 'investor-relation-report:cms',
	investorFinancialReport: 'investor-relation-financial-report:cms',
    investorPromotion: 'investor-relation-promotion:cms',
	investorMeet: 'investor-relations-meet:cms',
	investorRecentHighlights: 'investor-relation-recent-highlight:cms',
	investorNews: 'investor-relations-news:cms',
    queryContract: 'general-elec-protocols:cms'// 获取协议信息
}

// 特殊入仓
const specialWarehousing = {
	querySpecialWarehousing: "specialStorage/address/query:new"
}

Object.assign(
	(window.urlConfigs = {}),
	common,
	login,
	order,
	waybill,
	addressBook,
	region,
	feedback,
	accept,
	product,
	coupon,
	onlineService,
	price,
	cmsApi,
	specialWarehousing
);



// WEBPACK FOOTER //
// ./src/api/interface.js